import SlideManager from "../slide-manager";
import getVWKey from "../../helpers/getVWKey";

const returnTimeouts = new WeakMap();

function initObjectReturn(controlsObjRot) {
    controlsObjRot.events.addEventListener('dragstart', ({ object }) => {

        clearObjectTimeout(object);
    });

    controlsObjRot.events.addEventListener('dragstop', ({ apply: altKey, object }) => {
        restartObjectTimeout(altKey, object);
    });

    controlsObjRot.events.addEventListener('execute', ({ apply: altKey, object }) => {
        restartObjectTimeout(altKey, object);
    });
}

function saveState(object) {
    const data = SlideManager.currentSlide.animation[object.uuid];
    const vpType = getVWKey();

    const saveObject = vpType === "sizeSm"
        ? data[vpType] = data[vpType] || {
            position: { x: 0, y: 0, z: 0 },
            scale: { x: 1, y: 1, z: 1 },
            rotation: { x: 0, y: 0, z: 0 }
        }
        : data;


    saveObject.rotation.x = object.rotation.x;
    saveObject.rotation.y = object.rotation.y;
    saveObject.rotation.z = object.rotation.z;

    saveObject.scale.x = object.scale.x;
    saveObject.scale.y = object.scale.y;
    saveObject.scale.z = object.scale.z;

    saveObject.position.x = object.position.x;
    saveObject.position.y = object.position.y;
    saveObject.position.z = object.position.z;
}

function clearObjectTimeout(object) {
    let timeout = returnTimeouts.get(object);
    if (timeout) {
        clearTimeout(timeout);
        returnTimeouts.delete(object);
    }
}

function restartObjectTimeout(altKey, object) {
    clearObjectTimeout(object);

    const timeout = setTimeout(() => {
        returnTimeouts.delete(object);
        returnObject(altKey, object);
    }, 3000);

    returnTimeouts.set(object, timeout);
}

function returnObject(altKey, object) {

    if (!Q3.editMode || Q3.selectingMesh) {
        const slideQuiz = SlideManager.currentSlide.slideQuiz;

        if (slideQuiz && slideQuiz.type === "select" && (slideQuiz.hasSelected || Q3.selectingMesh)) {
            return;
        }
    }

    if (altKey) {
        saveState(object);
        return;
    }

    const uuid = object.uuid;
    const objectData = Q3.data.assets.objects[uuid];
    let animData = SlideManager.currentSlide.animation[uuid];

    if (!(objectData && animData)) return;

    const vpType = getVWKey();

    animData = vpType === 'sizeSm' && animData[vpType] || animData;

    const saveObject = animData;

    const { x, y, z } = saveObject.rotation;
    const targetEuler = new THREE.Euler(x, y, z, objectData.rotation.order);
    const targetQuaternion = new THREE.Quaternion().setFromEuler(targetEuler);
    const startQuaternion = new THREE.Quaternion().setFromEuler(object.rotation);
    const currentQuaternion = new THREE.Quaternion();
    const currentEuler = new THREE.Euler(0, 0, 0, objectData.rotation.order);

    const t = { value: 0 };
    const t0 = { value: 0 };
    const t1 = {
        value: 1,
        onUpdate: () => {
            THREE.Quaternion.slerp(startQuaternion, targetQuaternion, currentQuaternion, t.value);
            currentEuler.setFromQuaternion(currentQuaternion, objectData.rotation.order);
            limitEulerToHalfTurn(currentEuler, saveObject.rotation, object.rotation);

            Q3.RenderManager.shadowMap.needsUpdate = true;
            Q3.RenderManager.activeCamera.update = true;
        }
    };

    TweenMax.to(object.position, 0.25, saveObject.position);
    TweenMax.fromTo(t, 0.25, t0, t1);
    TweenMax.to(object.scale, 0.25, saveObject.scale);
}

const PI2 = 2 * Math.PI;
const axes = ['x', 'y', 'z'];

function limitEulerToHalfTurn(euler, refEuler, outEuler) {
    for (let axis of axes) {
        let d = euler[axis] - refEuler[axis];
        d -= Math.round(d / PI2) * PI2;
        outEuler[axis] = refEuler[axis] + d;
    }
    return outEuler;
}

export default initObjectReturn;
